import { Container, Grid } from "@mui/material";
import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'
import SectionHeading from "../../Components/SectionHeading";

import pcs_p from "../../images/pcs_p.png"
import bscscan from "../../images/bscscan_p.png"
import cmc_p from "../../images/cmc_p.png"
import gc_p from "../../images/gc_p.png"

const Partners = () => {
    useEffect(() =>{
        AOS.init({duration: 2000})
    })
    return(
        <div className="py-5">
            <Container>
                <Grid
                    container
                    justifyContent="center"
                    alignContent="center"
                    className="pt-md-5"
                >
                    <Grid
                        xs={12}
                        data-aos="zoom-in"
                    >
                        <SectionHeading
                            subHeading = "Helpful Links"
                            heading = "Catch Up With Us" 
                            customClass = " mx-auto text-center"
                        />
                    </Grid>
                    <Grid
                        container
                        xs={12}
                        sm={11}
                        md={8}
                    >
                        <Grid
                            xs={6}
                            sm={3}
                            className="text-center pt-4"
                            data-aos="zoom-in"
                        >
                            <img src={pcs_p} className="img-fluid d-inline-block mx-3" style={{height: 100, width: 'auto'}} />
                            <h6 className="mb-0 mt-3">Pancakeswap</h6>
                        </Grid>
                        <Grid
                            xs={6}
                            sm={3}
                            className="text-center pt-4"
                            data-aos="zoom-in"
                        >
                            <img src={bscscan} className="img-fluid d-inline-block mx-3" style={{height: 100, width: 'auto'}} />
                            <h6 className="mb-0 mt-3">Bsc Scan</h6>
                        </Grid>
                        <Grid
                            xs={6}
                            sm={3}
                            className="text-center pt-4"
                            data-aos="zoom-in"
                        >
                            <img src={cmc_p} className="img-fluid d-inline-block mx-3" style={{height: 100, width: 'auto'}} />
                            <h6 className="mb-0 mt-3">CoinMarketCap</h6>
                        </Grid>
                        <Grid
                            xs={6}
                            sm={3}
                            className="text-center pt-4"
                            data-aos="zoom-in"
                        >
                            <img src={gc_p} className="img-fluid d-inline-block mx-3" style={{height: 100, width: 'auto'}} />
                            <h6 className="mb-0 mt-3">Coingecko</h6>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default Partners;